import request, { METHODS } from "src/utils/api-base";

const planApis = {
  createPlan: (payload: { page: number; limit: number }) => {
    return request({
      route: "/admin/plan/create",
      method: METHODS.POST,
      payload,
      auth: true,
      isAdminAuth: true,
    });
  },
  editPlan: (payload: any) => {
    return request({
      route: `/admin/plan/${payload._id}`,
      method: METHODS.PUT,
      payload,
      auth: true,
      isAdminAuth: true,
    });
  },
  getPlanDetails: (planId: string) => {
    return request({
      route: `/admin/plan/${planId}`,
      method: METHODS.GET,
      auth: true,
      isAdminAuth: true,
    });
  },
  getPlanList: (params: {
    page: number;
    limit: number;
    status?: "active" | "suspended";
    search?: string;
  }) => {
    return request({
      route: "/admin/plan/list",
      method: METHODS.GET,
      params,
      auth: true,
      isAdminAuth: true,
    });
  },
  getPublicPlanList: () => {
    return request({
      route: "/admin/plan/list-public",
      method: METHODS.GET,
    });
  },
};

export default planApis;
